import {axiosInstance} from './axios';

export async function getBusesApi(query='') {
  try {
    return await axiosInstance.get(`/api/v1/bus?${query}`)
  }catch (e) {
    return null;
  }
}

export async function addBusApi(data) {
  try {
    return await axiosInstance.post("/api/v1/bus",data)
  }catch (e) {
    return null;
  }
}
export async function assignDriverToBus(data,id) {
  try {
    return await axiosInstance.post(`/api/v1/bus/${id}/assign`,data)
  }catch (e) {
    return null;
  }
}


export async function getBusApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/bus/${id}`)
  }catch (e) {
    return null;
  }
}
export async function getBusServicesApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/bus-services?bus=${id}`)
  }catch (e) {
    return null;
  }
}
export async function unAssignDriverApi(id,driver) {
  try {
    return await axiosInstance.post(`/api/v1/unAssign/${id}/remove/${driver}`,[])
  }catch (e) {
    return null;
  }
}

export async function editBusApi(data,id) {
  try {
    return await axiosInstance.put(`/api/v1/bus/${id}`,data)
  }catch (e) {
    return null;
  }
}

export async function removeBusApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/bus/${id}`)
  }catch (e) {
    return null;
  }
}
